import { checkNull2Int, checkNull2String, checkNull2Json } from "./ItemTools"

export class ReqResumeList {
    constructor({ start, limit, name, address, jobStatus, skill, isPublic = true }) {
        this.start = start
        this.limit = limit
        if (name !== undefined && name !== "") {
            this.name = name
        }
        if (address !== undefined && address !== "") {
            this.address = address
        }
        if (jobStatus !== undefined && jobStatus !== "") {
            this.jobStatus = jobStatus
        }
        if (skill !== undefined && skill !== "") {
            this.skill = skill
        }
        this.isPublic = isPublic
    }

    fromJson(jsonData) {
        if (jsonData.name !== undefined)
            this.name = jsonData.name
        if (jsonData.address !== undefined)
            this.address = jsonData.address
        if (jsonData.jobStatus !== undefined)
            this.jobStatus = jsonData.jobStatus
        if (jsonData.skill !== undefined)
            this.skill = jsonData.skill
    }
}


export class ReqResumeAdd {
    constructor({ idNumber, birthday, isEmployee = 0, isPublic = 0 }) {
        this.idNumber = idNumber
        this.birthday = birthday
        this.isEmployee = isEmployee
        this.isPublic = isPublic
    }

    fromJson(jsonData) {
        this.idNumber = jsonData.idNumber
        this.birthday = jsonData.birthday
        this.name = checkNull2String(jsonData.name)
        this.sex = checkNull2Int(jsonData.sex)
        this.mobile = checkNull2String(jsonData.mobile)
        this.lineId = checkNull2String(jsonData.lineId)
        //this.idNumber = checkNull2String(jsonData.idNumber)
        //this.birthday = checkNull2String(jsonData.birthday, "0000-00-00")
        this.height = checkNull2Int(jsonData.height)
        this.weight = checkNull2Int(jsonData.weight)
        this.marriage = checkNull2Int(jsonData.marriage)
        this.military = checkNull2Int(jsonData.military)
        this.exMilitary = checkNull2String(jsonData.exMilitary)
        this.residentialAddress = checkNull2String(jsonData.residentialAddress)
        this.mailingAddress = checkNull2String(jsonData.mailingAddress)
        this.skills = JSON.stringify(checkNull2Json(jsonData.skills, []))
        this.isEmployee = checkNull2Int(jsonData.isEmployee)
        this.isPublic = checkNull2Int(jsonData.isPublic)
        this.creatAccountId = jsonData.creatAccountId
    }

    toString() {
        return 'Name: ' + this.fullName + ', Age:' + this.age
    }
}
export class ReqResumeEdit {
    constructor({ resumeId, birthday }) {
        this.resumeId = resumeId
        this.birthday = birthday
    }

    fromJson(jsonData) {
        this.resumeId = jsonData.resumeId
        this.birthday = jsonData.birthday
    }
}

export class ReqResumeDetail {
    constructor({ resumeId }) {
        this.resumeId = resumeId
    }
}

export class RespResumeDetail {
    constructor({ resumeId = "", birthday = "", resumeDatas = {}, creatAccountId = "", creatAt = "" }) {
        this.resumeId = resumeId
        this.birthday = birthday
        this.resumeDatas = resumeDatas
        this.creatAccountId = creatAccountId
        this.creatAt = creatAt
    }
    setResumeData(key, val) {
        if (this.resumeDatas === undefined) {
            this.resumeDatas = {}
        }
        this.resumeDatas[key] = new RespResumeOtherData({})
        this.resumeDatas[key].fromJson(val)
    }

    fromJson(jsonData) {
        if (typeof jsonData === "string")
            jsonData = JSON.parse(jsonData)

        this.resumeId = jsonData.resumeId
        this.idNumber = jsonData.idNumber
        this.birthday = jsonData.birthday
        this.resumeDatas = jsonData.resumeDatas
        this.creatAccountId = jsonData.creatAccountId
        this.creatAt = jsonData.creatAt
    }
}

export class ReqResumeOtherData {
    constructor({ resumeId = "", resumeKey = "" }) {
        this.resumeId = resumeId
        this.resumeKey = resumeKey
    }
}

export class RespResumeOtherData {
    constructor({ companyId, resumeId, resumeKey, resumeData, creatAccountId, creatAt }) {
        if (companyId !== undefined)
            this.companyId = companyId
        this.resumeId = resumeId
        this.resumeKey = resumeKey
        this.resumeData = resumeData
        if (creatAccountId !== undefined)
            this.creatAccountId = creatAccountId
        if (creatAt !== undefined)
            this.creatAt = creatAt
    }
    setNickName({ nickName, accountId }) {
        this.nickName = nickName
        this.accountId = accountId
    }
}

export class RespResumeOtherDataBase {
    constructor({
        resumeId = "",
        idNumber = "",       //身分證
        employeeId = "",   //員工編號(內部)
        enrollDate = "",   //到職日(內部)
        name = "",         //姓名
        sex = "",          //性別
        mobile = "",       //手機號碼
        lineId = "",       //Line ID
        birthday = "",     //生日
        height = "",       //身高
        weight = "",       //體重
        marriage = "",     //婚姻狀態
        military = "",     //兵役狀態
        exMilitary = "",   //免役原因
        residentialAddress = "",   //戶籍地址
        mailingAddress = "",       //通訊地址
        driverLicense = [],        //駕照
        transport = [],            //交通工具
        skills = [],               //專長
        otherSkill = "",           //其他專長
    }) {
        this.resumeId = resumeId
        this.idNumber = idNumber
        this.employeeId = employeeId
        this.enrollDate = enrollDate
        this.birthday = birthday
        this.name = name
        this.sex = sex
        this.mobile = mobile
        this.lineId = lineId
        this.height = height
        this.weight = weight
        this.marriage = marriage
        this.military = military
        this.exMilitary = exMilitary
        this.residentialAddress = residentialAddress
        this.mailingAddress = mailingAddress
        this.driverLicense = driverLicense
        this.transport = transport
        this.skills = skills
        this.otherSkill = otherSkill
    }

    fromJson(jsonData) {
        if (typeof jsonData === "string")
            jsonData = JSON.parse(jsonData)

        if (jsonData === null || jsonData === undefined) {
            //this.resumeId = ""
            //this.idNumber = ""
            //this.birthday = ""
            this.employeeId = ""
            this.enrollDate = ""
            this.name = ""
            this.sex = ""
            this.mobile = ""
            this.lineId = ""
            this.height = ""
            this.weight = ""
            this.marriage = ""
            this.military = ""
            this.exMilitary = ""
            this.residentialAddress = ""
            this.mailingAddress = ""
            this.driverLicense = []
            this.transport = []
            this.skills = []
            this.otherSkill = ""
            this.isEmployee = ""
            this.creatAccountId = ""
            this.creatAt = ""
        } else {
            //console.log(jsonData)
            this.resumeId = jsonData.resumeId
            this.idNumber = jsonData.idNumber
            this.employeeId = jsonData.employeeId
            this.enrollDate = jsonData.enrollDate
            this.birthday = jsonData.birthday
            this.name = jsonData.name
            this.sex = jsonData.sex
            this.mobile = jsonData.mobile
            this.lineId = jsonData.lineId
            //this.idNumber = checkNull2String(jsonData.idNumber)
            //this.birthday = checkNull2String(jsonData.birthday, "0000-00-00")
            this.height = jsonData.height
            this.weight = jsonData.weight
            this.marriage = jsonData.marriage
            this.military = jsonData.military
            this.exMilitary = jsonData.exMilitary
            this.residentialAddress = jsonData.residentialAddress
            this.mailingAddress = jsonData.mailingAddress
            this.driverLicense = jsonData.driverLicense !== undefined ? jsonData.driverLicense : []
            this.transport = jsonData.transport !== undefined ? jsonData.transport : []
            this.skills = jsonData.skills !== undefined ? jsonData.skills : []
            this.otherSkill = jsonData.otherSkill
            this.isEmployee = jsonData.isEmployee
            this.creatAccountId = jsonData.creatAccountId
            this.creatAt = jsonData.creatAt
        }
    }
}

export class RespResumeOtherDataFamily {
    constructor({ familyList = [], emergencyContact = {} }) {
        this.familyList = familyList
        this.emergencyContact = emergencyContact
    }
    fromJson(jsonData) {
        //console.log(jsonData)
        if (typeof jsonData === "string")
            jsonData = JSON.parse(jsonData)
        //console.log(typeof jsonData)
        //console.log("jsonData.family")
        //console.log(jsonData)
        if (jsonData === null || jsonData === undefined || jsonData.familyList === undefined) {
            this.familyList = []
            this.familyList.push(new RespResumeOtherDataFamilyList({}))
            this.familyList.push(new RespResumeOtherDataFamilyList({}))
        } else {
            this.familyList = jsonData.familyList
        }
        if (jsonData === null || jsonData === undefined || jsonData.emergencyContact === undefined) {
            this.emergencyContact = new RespResumeOtherDataEmergencyContact({})
        } else {
            this.emergencyContact = jsonData.emergencyContact
        }
    }
}
/**
 * 家庭成員
 */
export class RespResumeOtherDataFamilyList {
    constructor({ name = "", relation = "", birthYear = "", job = "" }) {
        this.name = name
        this.relation = relation
        this.birthYear = birthYear
        this.job = job
    }

    fromJson(jsonData) {
        this.name = jsonData.name
        this.relation = jsonData.relation
        this.birthYear = jsonData.birthYear
        this.job = jsonData.job
    }
}
/**
 * 緊急聯絡人
 */
export class RespResumeOtherDataEmergencyContact {
    constructor({ name = "", relation = "", mobile = "", phone = "" }) {
        this.name = name
        this.relation = relation
        this.mobile = mobile
        this.phone = phone
    }
    fromJson(jsonData) {
        this.name = jsonData.name
        this.relation = jsonData.relation
        this.mobile = jsonData.mobile
        this.phone = jsonData.phone
    }
}

/**
 * 學歷列表
     * @param {*} param0 
 */
export class RespResumeOtherDataEducationList {
    constructor({ educationList }) {
        if (educationList === undefined) {
            this.educationList = []
            this.educationList.push(new RespResumeOtherDataEducation({}))
            this.educationList.push(new RespResumeOtherDataEducation({}))
            this.educationList.push(new RespResumeOtherDataEducation({}))
        }
        this.educationList = educationList
    }

    fromJson(jsonData) {
        if (jsonData === null || jsonData === undefined) {
            this.educationList = []
            this.educationList.push(new RespResumeOtherDataEducation({}))
            this.educationList.push(new RespResumeOtherDataEducation({}))
            this.educationList.push(new RespResumeOtherDataEducation({}))
        } else {
            if (typeof jsonData === "string")
                jsonData = JSON.parse(jsonData)
            this.educationList = jsonData
        }
    }
}
/**
 * 學歷
     * @param {*} param0 
 */
export class RespResumeOtherDataEducation {
    constructor({ schoolName = "", department = "", during = "", status = 0 }) {
        this.schoolName = schoolName
        this.department = department
        this.during = during
        this.status = status
    }
}


/**
 * 經歷列表
     * @param {*} param0 
 */
export class RespResumeOtherDataWorkExperiencesList {
    constructor({ workExperiencesList }) {
        this.workExperiencesList = workExperiencesList
    }

    fromJson(jsonData) {
        if (jsonData === null || jsonData === undefined) {
            this.workExperiencesList = []
            this.workExperiencesList.push(new RespResumeOtherDataWorkExperiences({}))
            this.workExperiencesList.push(new RespResumeOtherDataWorkExperiences({}))
        } else {
            if (typeof jsonData === "string")
                jsonData = JSON.parse(jsonData)
            this.workExperiencesList = jsonData
        }
    }
}
/**
 * 經歷
     * @param {*} param0 
 */
export class RespResumeOtherDataWorkExperiences {
    constructor({ companyName = "", workContent = "", salary = "", during = "", reasonsLeaving = "", jobContract = 0 }) {
        this.companyName = companyName
        this.workContent = workContent
        this.salary = salary
        this.during = during
        this.reasonsLeaving = reasonsLeaving
        this.jobContract = jobContract
    }
}


/**
 * 薪資領取方式列表
     * @param {*} param0 
 */
export class RespResumeOtherDataPayrollMethodList {
    constructor({ payrollMethodList }) {
        this.payrollMethodList = payrollMethodList
    }

    fromJson(jsonData) {
        if (jsonData === null || jsonData === undefined) {
            this.payrollMethodList = []
            this.payrollMethodList.push(new RespResumeOtherPayrollMethod({}))
        } else {
            if (typeof jsonData === "string")
                jsonData = JSON.parse(jsonData)
            this.payrollMethodList = jsonData
        }
    }
}
/**
 * 薪資領取方式
     * @param {*} param0 
 */
export class RespResumeOtherPayrollMethod {
    constructor({ method = "1", bankCode = "", bankName = "", bankBranchCode = "", bankBranchName = "", accountName = "", account = "", idNumber = "" }) {
        this.method = method
        this.bankCode = bankCode
        this.bankName = bankName
        this.bankBranchCode = bankBranchCode
        this.bankBranchName = bankBranchName
        this.accountName = accountName
        this.account = account
        this.idNumber = idNumber
    }
}


/**
 * 附件資料列表
     * @param {*} param0 
 */
export class RespResumeOtherDataAttachmentList {
    constructor({ attachmentList }) {
        this.attachmentList = attachmentList
    }


    fromJson(jsonData, parameterArray) {
        //console.log(jsonData)
        if (jsonData !== null && jsonData !== undefined) {
            if (typeof jsonData === "string")
                jsonData = JSON.parse(jsonData)
        }
        this.attachmentList = {}
        parameterArray.forEach(item => {
            if (jsonData !== null && jsonData !== undefined && jsonData[item.key] !== undefined) {
                this.attachmentList[item.key] = jsonData[item.key]
            } else {
                this.attachmentList[item.key] = new RespResumeOtherAttachment({})
            }
        });
    }
}
/**
 * 附件資料
     * @param {*} param0 
 */
export class RespResumeOtherAttachment {
    constructor({ filePath = "", fileName = "", fileType = "", note = "", creatAt = "" }) {
        this.filePath = filePath
        this.fileName = fileName
        this.fileType = fileType
        this.note = note
        this.creatAt = creatAt
    }
    fromJson(jsonData) {
        this.filePath = jsonData.filePath
        this.fileName = jsonData.fileName
        this.fileType = jsonData.fileType
        this.note = jsonData.note
        this.creatAt = jsonData.creatAt
    }
}
